import React, { useEffect, useState } from "react";
import { fetchLibrary } from "@/lib/api";
import Seo from "@/components/seo/Seo";

export default function Library() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetchLibrary().then((list) => {
      setItems(list);
      if (list.length) setActive(list[0]);
    });
  }, []);

  return (
    <div data-testid="library-page" className="pt-32 md:pt-40">
      <Seo
        path="/library"
        title="The Library"
        description="An index of primitives — plants, minerals, and methods we return to. A reference for the curious practitioner."
      />
      <section className="px-6 md:px-12 lg:px-16 pb-16">
        <p className="overline mb-6">The Library</p>
        <h1 className="font-display text-5xl md:text-7xl lg:text-[8rem] font-light leading-[0.92] tracking-[-0.03em] text-ink">
          An index<br />
          of <em className="italic text-moss">primitives.</em>
        </h1>
        <p className="mt-10 max-w-xl text-charcoal text-lg md:text-xl font-light leading-relaxed">
          Plants, minerals, and methods we return to. Each entry, short.
          The depth is in the practice.
        </p>
      </section>

      <section className="px-6 md:px-12 lg:px-16 py-12 border-t border-hairline">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* List */}
          <ul className="lg:col-span-5 border-t border-hairline">
            {items.map((it, idx) => {
              const isActive = active?.slug === it.slug;
              return (
                <li key={it.slug} className="border-b border-hairline">
                  <button
                    data-testid={`library-item-${it.slug}`}
                    onClick={() => setActive(it)}
                    className={`w-full text-left grid grid-cols-12 gap-4 py-5 md:py-6 items-baseline transition-colors ${
                      isActive ? "text-ink" : "text-charcoal hover:text-ink"
                    }`}
                  >
                    <span className="col-span-1 text-xs font-mono text-stone">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <span className={`col-span-7 font-display text-2xl md:text-3xl tracking-tight ${isActive ? "italic" : ""}`}>
                      {it.name}
                    </span>
                    <span className="col-span-4 text-right text-xs tracking-[0.15em] uppercase text-stone">
                      {it.origin.split(",")[0]}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>

          {/* Detail */}
          {active && (
            <aside className="lg:col-span-6 lg:col-start-7 lg:sticky lg:top-32 self-start" data-testid="library-detail">
              <p className="overline mb-4">N°{String(items.findIndex(i => i.slug === active.slug) + 1).padStart(2, '0')}</p>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink font-light leading-[1.0] tracking-tight">
                {active.name}
              </h2>
              <p className="font-display italic text-lg md:text-xl text-charcoal mt-3">{active.latin}</p>
              <div className="mt-6 grid grid-cols-2 gap-6 border-t border-hairline pt-6">
                <div>
                  <p className="overline mb-2">Origin</p>
                  <p className="text-base text-ink font-light">{active.origin}</p>
                </div>
                <div>
                  <p className="overline mb-2">Properties</p>
                  <ul className="space-y-1">
                    {active.properties.map((p) => (
                      <li key={p} className="font-display italic text-base text-ink">{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <p className="mt-8 text-lg md:text-xl text-charcoal font-light leading-[1.7] max-w-xl">
                {active.description}
              </p>
            </aside>
          )}
        </div>
      </section>
    </div>
  );
}
